import { render } from "./AddTemplateDialog.vue?vue&type=template&id=1963d51d&scoped=true"
import script from "./AddTemplateDialog.vue?vue&type=script&lang=js"
export * from "./AddTemplateDialog.vue?vue&type=script&lang=js"

import "./AddTemplateDialog.vue?vue&type=style&index=0&id=1963d51d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1963d51d"]])

export default __exports__